import * as React from 'react';
import { SVGProps } from 'react';

const SvgEllipseSingle = (
  props: SVGProps<SVGSVGElement> & React.HTMLAttributes<HTMLElement>
) => (
  <svg
    width={4}
    height={4}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={2} cy={2} r={2} fill="#3F4B5C" />
  </svg>
);
export default SvgEllipseSingle;
